module.exports = __webpack_public_path__ + "fonts/Clash-Bold.d7bff95.woff2";